import axios from 'axios';

const API_URL = 'https://api.u2lr.com/api';
const API_URL_2 = 'https://api.u2lr.com';
// const API_URL_3 = 'http://localhost:5000';

const api = axios.create({
  baseURL: API_URL,
});

const api2 = axios.create({
  baseURL: API_URL_2,
});

// Add JWT token to every request
[api, api2].forEach(instance => {
  instance.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
});

export { api, api2 }; // <-- export both
export default api;